import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-list-button__text" }

import ListIcon from '@/components/commons/icons/ListIcon.vue';
    import { cardSettingsStore } from '@/store/modules/CardSettings';
    import { TABLET_BOTTOM } from '@/constants/sizes';

    interface IProps {
        mode?: 'default' | 'filter';
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomListButton',
  props: {
    mode: { default: 'default' }
  },
  emits: ['click'],
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["custom-list-button", [_ctx.mode && `custom-list-button--mode-${_ctx.mode}`]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createVNode(ListIcon, { class: "custom-list-button__icon" }),
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})